import { SelectionUtil } from "../../../util/SelectionUtil";

export class AnnotationSelectionHandler  {
    static SECTION_WRAPPER_ID_PREFIX = 'gc-section-wrapper-';
    static SECTION_WRAPPER_CLASS = 'gc-section-action-wrapper';
    static REMOVE_SELECTORS_FROM_SELECTION = `
        .notes-expansion-panel-wrapper,
        .tags-expansion-panel-wrapper,
        .section-action-button-container,
        .content-section-tags,
        .content-section-breadcrumb
    `
    static highLightedSectionContent(sectionId) {
        const selectedWrapper = document.getElementById(`${this.SECTION_WRAPPER_ID_PREFIX}${sectionId}`);
        if (!selectedWrapper) return;

        const fullSelection = SelectionUtil.selectionAsElement();
        const multipleSectionsSelected = fullSelection.querySelectorAll(`.${this.SECTION_WRAPPER_CLASS}`).length > 1;

        const selectionRange = SelectionUtil.getSelectionRangeWithin(selectedWrapper);
        if (!selectionRange) return;

        const rangeElement = SelectionUtil.rangeToElement(selectionRange);
        this.removeUIArtifacts(rangeElement);

        let anchorNode = this.normalizeNode(selectionRange.startContainer);
        let focusNode = this.normalizeNode(selectionRange.endContainer);

        const text = rangeElement.textContent;
        const brCount = rangeElement.innerHTML.split('<br>').length - 1;
        if (!text.length) return;

        let startNode = (anchorNode.compareDocumentPosition(focusNode) & Node.DOCUMENT_POSITION_FOLLOWING) ? anchorNode : focusNode;
        let endNode = (startNode === anchorNode) ? focusNode : anchorNode;

        const endNodeCheck = ['A', 'SPAN', 'SUP', 'INS'];
        startNode = this.getRealNode(startNode, endNodeCheck);
        endNode = this.getRealNode(endNode, endNodeCheck);

        const section = startNode.closest(`.${this.SECTION_WRAPPER_CLASS}`);
        let chapterTitle = section.getAttribute('data-chapter-title')?.toLowerCase();
        const useExact = chapterTitle?.includes('definitions');

        const startNodeXPath = useExact
            ? this.buildExactXPath(section, startNode)
            : this.buildXPath(section, startNode);

        const endNodeXPath = useExact
            ? this.buildExactXPath(section, endNode)
            : this.buildXPath(section, endNode);

        let labelOffset = this.getLabelOffset(startNode);

        let startOffset = SelectionUtil.getOffsetsFromRange(startNode, selectionRange, 'start') + labelOffset;
        let endOffset = SelectionUtil.getOffsetsFromRange(endNode, selectionRange, 'end') + brCount + labelOffset;

        const highlightedText = {
            sectionId,
            text,
            selectionTruncatedToSingleSection: multipleSectionsSelected,
            startNode: startNodeXPath,
            endNode: endNodeXPath,
            startOffset,
            endOffset
        };

        return highlightedText;
    }

    static removeUIArtifacts(container) {
        container.querySelectorAll(this.REMOVE_SELECTORS_FROM_SELECTION).forEach(el => el.remove());
    }

    static normalizeNode(node) {
        if (node instanceof Element && node.classList.contains(this.SECTION_WRAPPER_CLASS)) {
            while (node.firstChild instanceof Element) {
                node = node.firstChild;
            }
        } else if (!(node instanceof Element)) {
            node = node.parentNode;
        }
        return node;
    }

    static getLabelOffset(node) {
        const firstChild = node.children?.[0];
        const hasLabel = firstChild?.classList?.contains('label');
        const hasTab = node.innerText?.includes('\t');
        return hasLabel && hasTab ? 1 : 0;
    }

    static getRealNode(node, tagBan) {
        if (_.includes(tagBan, node.tagName)) {
            return this.getParentNode(tagBan, node.parentElement);
        }
        return node;
    }

    static getParentNode(nodeCheck, node) {
        if (_.includes(nodeCheck, node.tagName))
            return this.getParentNode(nodeCheck, node.parentElement);
        else
            return node;
    }

    static buildXPath(section, node, xPath = []) {
        if (node.classList.contains(this.SECTION_WRAPPER_CLASS)) {
            return xPath.reverse().join('/');
        }

        const tagName = node.tagName.toLowerCase();
        if (!['span', 'a'].includes(tagName)) {
            const index = this.findIndex(node);
            xPath.push(`${tagName}[${index}]`);
        }

        return this.buildXPath(section, node.parentElement, xPath);
    }

    static buildExactXPath(section, node) {
        const sectionPath = this.getXPath(section);
        let nodeXPath = this.getXPath(node).replace(sectionPath, '');

        return nodeXPath
            .split('/')
            .filter(tag => tag && !tag.includes('span'))
            .join('/');
    }

    static getXPath(element) {
        let selector = '';
        let currentElement = element;

        while (currentElement && currentElement.tagName.toLowerCase() !== 'html') {
            const tagName = currentElement.tagName.toLowerCase();
            const parent = currentElement.parentElement;

            if (!parent) break;

            const siblings = [...parent.children].filter(el => el.tagName.toLowerCase() === tagName);
            const index = siblings.length > 1 ? `[${siblings.indexOf(currentElement) + 1}]` : '';

            selector = `/${tagName}${index}${selector}`;
            currentElement = parent;
        }

        return `/html${selector}`;
    }

    static findIndex(node) {
        if (!node || !node.parentElement) return -1;

        // Handle LI case separately
        if (node.tagName === 'LI') {
            return Array.from(node.parentElement.childNodes).indexOf(node) + 1;
        }

        let selector = node.tagName.toLowerCase() + ':not(.tag-icons)';
        let nodes = Array.from(node.parentElement.querySelectorAll(selector));

        // Apply filters
        nodes = nodes.filter(el => {
            const parentTag = el.parentElement?.tagName;
            const parentClass = el.parentElement?.classList;

            return (
                parentTag !== 'LI' &&
                !parentClass?.contains('exception')
            );
        });

        const index = nodes.indexOf(node);
        return index !== -1 ? index + 1 : this.findIndex(node.parentElement); // Recursive fallback
    }

}